// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.options-custom-select-wrapper {
  position: relative;
  min-width: 110px;
}

.options-custom-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background: #ffffff1c;
  border: 1px solid #e2e8f024;
  border-radius: 6px;
  font-size: 13px;
  color: #d7d7d7;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  min-width: 110px;
  height: 32px;
}

body.light_theme .options-custom-select-trigger {
  background: #fff;
  border: 1px solid #e2e8f0;
  color: #1e2329;
}

.options-custom-select-trigger:hover {
  border-color: #b7bdc633;
}

body.light_theme .options-custom-select-trigger:hover {
  border-color: #474d57;
}

.options-custom-select-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  background: #525458;
  border: 1px solid #e2e8f029;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 100;
  max-height: 200px;
  overflow-y: auto;
  padding: 4px 0;
}

body.light_theme .options-custom-select-menu {
  background: #fff;
  border: 1px solid #e2e8f0;
}

.options-custom-select-option {
  padding: 8px 12px;
  font-size: 13px;
  color: #eaecef;
  cursor: pointer;
  transition: background 0.2s;
}

body.light_theme .options-custom-select-option {

  color: #1e2329;
}

.options-custom-select-option:hover {
  background: #2b313900;
}

body.light_theme .options-custom-select-option:hover {

  background: #f8f9fa;
}

.options-custom-select-option.selected {

  color: #ffffff;
  font-weight: 500;
  background: #676767;
}

body.light_theme .options-custom-select-option.selected {
  background: #f8f9fa;
  color: #181818;
}

.options-custom-select-option.disabled {
  color: #b7bdc6;
  cursor: not-allowed;
}

body.dark_theme .options-custom-select-option.disabled {
  color: #5e6673;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/options/OptionsAssetSelect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".options-custom-select-wrapper {\n  position: relative;\n  min-width: 110px;\n}\n\n.options-custom-select-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 12px;\n  background: #ffffff1c;\n  border: 1px solid #e2e8f024;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #d7d7d7;\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n  min-width: 110px;\n  height: 32px;\n}\n\nbody.light_theme .options-custom-select-trigger {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  color: #1e2329;\n}\n\n.options-custom-select-trigger:hover {\n  border-color: #b7bdc633;\n}\n\nbody.light_theme .options-custom-select-trigger:hover {\n  border-color: #474d57;\n}\n\n.options-custom-select-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  width: 100%;\n  background: #525458;\n  border: 1px solid #e2e8f029;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 4px 0;\n}\n\nbody.light_theme .options-custom-select-menu {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n}\n\n.options-custom-select-option {\n  padding: 8px 12px;\n  font-size: 13px;\n  color: #eaecef;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\nbody.light_theme .options-custom-select-option {\n\n  color: #1e2329;\n}\n\n.options-custom-select-option:hover {\n  background: #2b313900;\n}\n\nbody.light_theme .options-custom-select-option:hover {\n\n  background: #f8f9fa;\n}\n\n.options-custom-select-option.selected {\n\n  color: #ffffff;\n  font-weight: 500;\n  background: #676767;\n}\n\nbody.light_theme .options-custom-select-option.selected {\n  background: #f8f9fa;\n  color: #181818;\n}\n\n.options-custom-select-option.disabled {\n  color: #b7bdc6;\n  cursor: not-allowed;\n}\n\nbody.dark_theme .options-custom-select-option.disabled {\n  color: #5e6673;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
